import createVueComponent from '../createVueComponent';
export default createVueComponent('outline', 'brand-vercel', 'BrandVercel', [["path",{"d":"M3 19h18l-9 -15z","key":"svg-0"}]]);